import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { autop } from '@wordpress/autop'
import { Modal } from 'antd'

import { TypeFactory, TypeElement } from '../Types'

function Attribute({
  onChange, value, ...props
}) {
  const { type, note } = props

  const [showNote, setShowNote] = useState(false)

  let TypeComponent = TypeFactory.create(type, props.code)
  /* eslint-disable-next-line no-unsafe-negation */
  if (!TypeComponent || !TypeComponent instanceof TypeElement) {
    TypeComponent = TypeFactory.create('input')

    if (process.env.NODE_ENV === 'development') {
      console.warn(`The [${type}] type is unsupported, fallback with input type`)
    }
  }

  const createNotesMarkup = () => {
    return { __html: autop(note) }
  }

  const formattedLabel = (attribute) => {
    let requiredMark = true === attribute.is_required ? '*':''
    return `${attribute.label} ${requiredMark}`
  }

  const _onCloseNote = () => setShowNote(false)
  const _onShowNote = () => setShowNote(true)

  return (
    <section className="PaAttribute">
      <h4 className="PaAttributeName">
        <span>{formattedLabel(props)} <span className="selected-attribute">{value && value.value}</span></span>

        {note && <Fragment>
          <button
            type="button"
            className="InlineHelpTips"
            onClick={_onShowNote}>?
          </button>

          <Modal
            closable={true}
            footer={false}
            width={'75%'}
            visible={showNote}
            onCancel={_onCloseNote}>
            <div dangerouslySetInnerHTML={createNotesMarkup()}></div>
          </Modal>
        </Fragment>}
      </h4>

      <div className="PaAttributeControl">
        <TypeComponent
          value={_.get(value, 'value')}
          attribute={props}
          onChange={(value) => onChange(value)}
        />
      </div>
    </section>
  )
}

Attribute.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  default_value: PropTypes.any,
  is_required: PropTypes.bool,
  is_unique: PropTypes.bool,
  label: PropTypes.string,
  note: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default Attribute
